Core.FileUpload = function(elem) {
    var NS = $(elem).closest('.portal-checkout__accordion-item').prop('id') || '';

    function fireEvent(name) {
        var event = new CustomEvent(name);
        document.dispatchEvent(event);
    }

    /*

        DATASET

     */

    function hasDataset(elem, name) {
        return elem &&
               elem.dataset &&
               typeof elem.dataset[name] !== 'undefined';
    }

    function warnData(name) {
        console.warn('Fileupload data for ' + name + ' missing');
        return;
    }

    function getDataset(elem, name) {
        return hasDataset(elem, name)
                            ? elem.dataset[name]
                            : warnData(name);
    }

    function getFileAllowed(elem) {
        var fileAllowedRaw = hasDataset(elem, 'fileAllowed')
                                ? elem.dataset.fileAllowed
                                : '';

        if (fileAllowedRaw.trim() === '') {
            return [];
        }

        var fileAllowed = fileAllowedRaw
                                .trim()
                                .split(',')
                                .map(function(el) {
                                    return el.trim().toLowerCase()
                                }).filter(function(el) {
                                    return (el.length > 0);
                                });

        return fileAllowed;
    }

    /*

        EVENTS

     */

    function preventDefaults (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    function getFileHtml(id, name) {
        return "<div class='fileUpload-file' data-file-id=" + id + ">" +
                "<span class='icon-file'></span> " +
                "<span class='fileUpload-filename'>" + name + "</span>" +
                "<div class='fileUpload-trail'></div>" +
                "<span class='fileUpload-loading'></span></div>";
    }

    function addDeleteButton(elem, name) {
        $(elem).find('.fileUpload-loading').remove();
        $(elem).append("<button class='fileUpload-delete' aria-label='Delete file: " + name + "' title='Delete file: " + name + "'> <span class='icon-delete'></span> </button>");
    }

    function appendHidden(elem, className, value) {
        $(elem).append('<input type="hidden" class="' + className + '" value="' + value + '">');
    }

    function recalculateHiddenFieldsNames(className) {
        var reorderName = function(elem, i) {
                              elem.name = className + '[' + i + ']';
                          };

        var list = el.elem.querySelectorAll('.' + className);

        Array.from(list).forEach(reorderName);
    }


    /*


        DOM


     */

    function getFileNameList() {
        var list = el.fileList.querySelectorAll('.fileUpload-filename');

        function getText(nodeDOM) {
            return nodeDOM.innerText;
        }

        return Array.from(list).map(getText);
    }

    var el = {
        elem: elem,
        input: elem.querySelector('.fileUpload-input'),
        target: elem.querySelector('.fileUpload-target'),
        fileList: elem.querySelector('.fileUpload-fileList'),
        errorWrap: elem.querySelector('.form-input'),
        errorText: elem.querySelector('.error'),
    };

    var data = {
        uploadId: getDataset(elem, 'uploadId'),
        uploadClass: getDataset(elem, 'uploadClass'),
        originalFileNameClass: getDataset(elem, 'originalFileNameClass'),
        apiUpload: getDataset(elem, 'apiUpload'),
        apiDelete: getDataset(elem, 'apiDelete'),
        fileSize: getDataset(elem, 'fileSize') || 5,
        fileAllowed: getFileAllowed(elem),
        fileNameList: getFileNameList(),
        isMultiple: (typeof el.input.attributes['multiple'] !== 'undefined')
    };

    // Methods
    var m = {
        init: function() {
            if (typeof data.uploadId === 'undefined' ||
                typeof data.apiUpload === 'undefined' ||
                typeof data.apiDelete === 'undefined') {
                return;
            }

            m.boot();
        },

        boot: function() {
            m.onDragAndDrop();
            m.onClickDelete();
        },

        onDragAndDrop: function() {
            // Prevent default drag behaviors
            [
                'dragenter',
                'dragover',
                'dragleave',
                'drop'
            ].forEach(function(eventName) {
                el.target.addEventListener(eventName, preventDefaults, false);
                document.body.addEventListener(eventName, preventDefaults, false);
            });

            // Highlight drop area when item is dragged over it
            ['dragenter', 'dragover'].forEach(function(eventName) {
                el.target.addEventListener(eventName, function(e) { elem.classList.add('fileUpload-highlight'); }, false);
            });

            ['dragleave', 'drop'].forEach(function(eventName) {
                el.target.addEventListener(eventName, function(e) { elem.classList.remove('fileUpload-highlight'); }, false);
            });

            el.target.addEventListener('drop', function(e) { Array.from(e.dataTransfer.files).forEach(m.uploadFile); }, false);

            // enable upload same file after delete
            el.input.addEventListener('keydown', function() { this.value = null; });
            el.input.addEventListener('click', function() { this.value = null; });
            el.input.addEventListener('change', function(e) { Array.from(e.target.files).forEach(m.uploadFile); }, false);
        },

        showError: function(msg) {
            el.errorWrap.classList.remove('d-none');
            el.errorText.innerText = msg;
        },


        /*


            UPLOAD
            allowSameName: allow upload same file name (Modify existing photo)

         */

        uploadFile: function(file, i, successCb, failCb, allowSameName) {
            if (!allowSameName && data.isMultiple && data.fileNameList.includes(file.name)) {
                m.showError('Upload file with the same name is not allowed');
                if (failCb && typeof failCb === 'function') failCb();                    
                return;
            }

            if (! data.isMultiple && data.fileNameList.length === 1) {
                m.showError('You can only upload only one file. Delete the current file before upload.');
                if (failCb && typeof failCb === 'function') failCb();
                return;
            }

            if (data.fileAllowed.length > 0) {
                var extension = file.name.split('.').length > 1
                                ? file.name.toLowerCase().split('.').pop()
                                : '';

                if (data.fileAllowed.indexOf(extension) === -1) {
                    m.showError('File extension "' + extension + '" is not allowed');
                    if (failCb && typeof failCb === 'function') failCb();
                    return;
                }
            }

            if ((file.size / (1000 * 1000)).toFixed(2) > parseInt(data.fileSize)) {
                m.showError(`The maximum file size allowed is ${data.fileSize}MB`);
                if (failCb && typeof failCb === 'function') failCb();
                return;
            }

            var formData = new FormData();
            formData.append('uploadId', data.uploadId);
            formData.append('file', file);
            formData.append('fileSize', parseInt(data.fileSize));

            var inputId = i + '-' + Date.now();

            (data.isMultiple)
                ? $(el.fileList).append(getFileHtml(inputId, file.name))
                : $(el.fileList).html(getFileHtml(inputId, file.name));

            el.errorWrap.classList.add('d-none');

            if (!allowSameName) {
                data.fileNameList.push(file.name);
            }

            $.ajax({
                type: 'POST',
                url: data.apiUpload,
                data: formData,
                processData: false,
                contentType: false,
                success: function(resp) {
                    var elem = el.elem.querySelector('[data-file-id="' + inputId + '"]');
                    resp = typeof resp === 'string' ? JSON.parse(resp) : resp;

                    elem
                        && ( setTimeout(function() { addDeleteButton(elem, file.name); }, 250)
                           , appendHidden(elem, data.uploadClass, resp.hash)
                           , recalculateHiddenFieldsNames(data.uploadClass)
                           , appendHidden(elem, data.originalFileNameClass, resp.originalFileName)
                           , recalculateHiddenFieldsNames(data.originalFileNameClass)
                           , fireEvent(`${NS ? NS + '.' : ''}fileUploaded`)
                        );
                    
                    if (successCb && typeof successCb === 'function') {
                        successCb(resp);
                    }
                },
                error: function(error) {
                    var elem = el.elem.querySelector('[data-file-id="' + inputId + '"]');

                    data.fileNameList = data.fileNameList.filter(function(fileName) { return fileName !== file.name; });

                    error.responseText
                        ? m.showError('Error Occurred: ' + error.responseText)
                        : m.showError('Error uploading ' + file.name + ' try later');

                    elem
                        && $(elem).remove();

                    if (failCb && typeof failCb === 'function') failCb();
                }
            });
        },


        /*


            DELETE


         */

        onClickDelete: function() {
            el.fileList.addEventListener('click', preventDefaults, false);
            el.fileList.addEventListener('click', m.handleDelete, false);
        },

        handleDelete: function(e) {
            function isDeleteButton(elem) {
                return (elem.classList.contains('fileUpload-delete') || elem.classList.contains('icon-delete'));
            }

            function hasFileId(elem) {
                var fileRow = findFileRow(elem, 0);
                var fileId = fileRow.querySelector('input[type=hidden]');

                return (fileId);
            }

            function getFileId(elem) {
                var fileRow = findFileRow(elem, 0);
                var fileId = fileRow.querySelector('input[type=hidden]');

                return fileId.value;
            }

            function findFileRow(elem, attempt) {
                if (elem.parentElement.classList.contains('fileUpload-file')) {
                    return elem.parentElement;
                }

                if (attempt > 2) {
                    return;
                }

                return findFileRow(elem.parentElement, attempt + 1);
            }

            function deleteFileRow(elem) {
                var fileRow = findFileRow(elem, 0);

                fileRow
                    && $(fileRow).remove();
            }

            /*


                Remove file name from file data.fileNameList.
                This is to allow re-upload a file after deletion.


             */
            function freeFileNameFromFileList(elem) {
                // is modifying, skip filter out
                if (elem.dataset.isModifying) return;

                var fileRow = findFileRow(elem, 0);
                var fileNameDom = fileRow && fileRow.querySelector('.fileUpload-filename');

                function filterOutFile(fileName) {
                    return fileName !== fileNameDom.innerText;
                }

                fileNameDom &&
                    (data.fileNameList = data.fileNameList.filter(filterOutFile));
            }

            function callApiDelete(elem) {
                var formData = new FormData();
                var isModifying = elem.dataset.isModifying;
                formData.append('uploadId', data.uploadId);
                formData.append('fileId', getFileId(elem));

                $.ajax({
                    type: 'POST',
                    url: data.apiDelete,
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function(resp) {
                        deleteFileRow(elem);
                        freeFileNameFromFileList(elem);
                        fireEvent(`${NS ? NS + '.' : ''}fileDeleted`);
                        // delete from vars
                        if (m.onDeleteSuccess && typeof m.onDeleteSuccess === 'function') m.onDeleteSuccess(data.fileNameList, isModifying);
                    },
                    error: function(error) {
                        m.showError('Error Occurred: ' + error.responseText);
                    }
                });
            }

            isDeleteButton(e.target)
                && hasFileId(e.target)
                && callApiDelete(e.target);
        },

        onDeleteSuccess: null,
    };

    return m;
};
